import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// WITHDRAWAL APIS (FormData-based)
// Controller: Withcon.php
// ================================

// 1) Wallet Summary
export async function getWalletSummary(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}withcon/get_wallet_summary`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Get Withdrawals
export async function getWithdrawals(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("page_no", payload.page_no ?? 0);
    fd.append("keyword", payload.keyword || "");

    fd.append("statusFilter", payload.statusFilter || "");
    fd.append("methodFilter", payload.methodFilter || "");
    fd.append("sortBy", payload.sortBy || "NEWEST");

    const res = await axios.post(`${apiBaseUrl}withcon/get_withdrawals`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Get Withdrawal By ID
export async function getWithdrawalById(withdraw_id) {
  try {
    const fd = new FormData();
    fd.append("withdraw_id", withdraw_id);

    const res = await axios.post(`${apiBaseUrl}withcon/get_withdrawal_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 4) Approve Withdrawal
export async function approveWithdrawal(withdraw_id, admin_id) {
  try {
    const fd = new FormData();
    fd.append("withdraw_id", withdraw_id);
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}withcon/approve_withdrawal`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 5) Reject Withdrawal
export async function rejectWithdrawal(withdraw_id, admin_id, reason) {
  try {
    const fd = new FormData();
    fd.append("withdraw_id", withdraw_id);
    fd.append("admin_id", admin_id);
    fd.append("reason", reason);

    const res = await axios.post(`${apiBaseUrl}withcon/reject_withdrawal`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 6) Settle Withdrawal
export async function settleWithdrawal(payload) {
  try {
    const fd = new FormData();
    fd.append("withdraw_id", payload.withdraw_id || "");
    fd.append("admin_id", payload.admin_id || "");
    fd.append("txn_id", payload.txn_id || "");
    fd.append("utr", payload.utr || "");
    fd.append("paid_at", payload.paid_at || "");

    const res = await axios.post(`${apiBaseUrl}withcon/settle_withdrawal`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 7) Export Withdrawals Excel
export async function exportWithdrawalsXl(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("keyword", payload.keyword || "");
    fd.append("statusFilter", payload.statusFilter || "");
    fd.append("methodFilter", payload.methodFilter || "");
    fd.append("sortBy", payload.sortBy || "NEWEST");

    const res = await axios.post(`${apiBaseUrl}withcon/export_withdrawals_xl`, fd, {
      responseType: "blob",
    });

    return res;
  } catch (err) {
    return null;
  }
}

// 8) Add Funds
export async function addFunds(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("amount", payload.amount || "");
    fd.append("method", payload.method || "cash");
    fd.append("ref", payload.ref || "");
    fd.append("remark", payload.remark || "");

    const res = await axios.post(`${apiBaseUrl}withcon/add_funds`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
